import React from 'react';

class AMDSEVExplanation extends React.Component {
	render() {
		return (
			<div className="fullwidth dark">
				<div className="row">
					<div className="twelve columns text-center">
						<h2>What is AMD SEV? Understanding Hardware-Enforced Encryption</h2>
						<p style={{fontSize: '1.1em', marginBottom: '40px'}}>The technology that makes confidential computing possible</p>
					</div>
				</div>
				<div className="row">
					<div className="six columns">
						<div className="panel bordered">
							<h3>What AMD SEV Actually Does</h3>
							<p><strong>AMD Secure Encrypted Virtualization (SEV)</strong> is a processor-level security feature that encrypts your virtual machine's memory using encryption keys that are <strong>generated and stored inside the CPU itself</strong>. These keys never leave the processor - not even the hypervisor (the software that manages virtual machines) can access them.</p>
							<p>Think of it this way: In a traditional server, your data sits in RAM like an open book that anyone with access can read. With AMD SEV, your data is encrypted by the CPU before it even reaches RAM, and only your specific virtual machine has the key to decrypt it - a key that exists only inside the processor chip.</p>
						</div>
					</div>
					<div className="six columns">
						<div className="panel bordered">
							<h3>Why Software Encryption Isn't Enough</h3>
							<p><strong>Software encryption</strong> runs on top of the operating system, which means it can be bypassed, disabled, or accessed by anyone with root privileges. If someone compromises the host system, gains physical access, or even just has administrative rights, they can potentially access your encrypted data.</p>
							<p><strong>Hardware encryption with AMD SEV</strong> operates at the processor level, below the operating system. Even if someone has root access to the host, physical access to the server, or control of the hypervisor, they <strong>cannot</strong> access your encrypted memory because the CPU itself prevents it - it's a physical, hardware-enforced barrier.</p>
						</div>
					</div>
				</div>
				<div className="row" style={{marginTop: '40px'}}>
					<div className="twelve columns">
						<div className="panel bordered">
							<h3>The Complete Picture: Memory + Disk Encryption</h3>
							<p>AMD SEV encrypts your memory (RAM), but we go further by also encrypting your disk storage with user-controlled keys. This means your data is protected both <strong>in use</strong> (memory) and <strong>at rest</strong> (disk), with you in complete control of the decryption keys.</p>
							<div className="row" style={{marginTop: '30px'}}>
								<div className="three columns">
									<h4>Memory Encryption</h4>
									<hr className="grey" />
									<p>AMD SEV encrypts RAM - your data is protected while being processed</p>
								</div>
								<div className="three columns">
									<h4>Disk Encryption</h4>
									<hr className="grey" />
									<p>AES-256 encryption for storage - your data is protected when saved</p>
								</div>
								<div className="three columns">
									<h4>Key Management</h4>
									<hr className="grey" />
									<p>You control the keys through our exclusive control panel</p>
								</div>
								<div className="three columns">
									<h4>No Trust Required</h4>
									<hr className="grey" />
									<p>The CPU enforces security - no need to trust the host or hypervisor</p>
								</div>
							</div>
							<div className="row" style={{marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '5px'}}>
								<div className="twelve columns">
									<p style={{fontSize: '1.1em', fontStyle: 'italic', margin: 0}}>
										<strong>Hardware-enforced security means your data is protected by the processor itself, not just software that can be disabled or bypassed.</strong>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default AMDSEVExplanation;
